import type { ReactNode } from 'react';

/*
 * Shows a message the way WhatsApp will: *bold*, _italic_, ~strikethrough~ and "- " bullets.
 * Same rules as WhatsApp: a marker opens after a space or the line start, closes before a space,
 * punctuation or the line end, and never spans lines. Links are left exactly as written.
 */
const URL = /((?:https?|upi):\/\/\S+)/g;
const STYLE = /(^|[\s(])([*_~])(?!\s)(.+?)(?<!\s)\2(?=$|[\s.,!?:;)])/g;
const TAG = { '*': 'strong', _: 'em', '~': 's' } as const;

function styled(text: string, key: string): ReactNode[] {
  const out: ReactNode[] = [];
  let last = 0;
  let n = 0;
  for (const m of text.matchAll(STYLE)) {
    const [whole, before = '', mark, inner = ''] = m;
    const start = m.index ?? 0;
    out.push(text.slice(last, start) + before);
    const Tag = TAG[mark as keyof typeof TAG];
    out.push(<Tag key={`${key}-${n++}`}>{inner}</Tag>);
    last = start + whole.length;
  }
  out.push(text.slice(last));
  return out;
}

function line(text: string, i: number): ReactNode[] {
  const body = text.startsWith('- ') ? `• ${text.slice(2)}` : text;
  return body.split(URL).flatMap((part, j): ReactNode[] =>
    j % 2 === 1 ? [<span key={`${i}-u${j}`} className="wa-link">{part}</span>] : styled(part, `${i}-${j}`),
  );
}

export function WhatsAppText({ text }: { text: string }) {
  return <>{text.split('\n').flatMap((l, i) => (i === 0 ? line(l, i) : ['\n', ...line(l, i)]))}</>;
}
